/** Geliştirme / map_id tanımlı değilken Advanced Marker için Google demo Map ID */
export const GOOGLE_MAPS_DEMO_MAP_ID = 'DEMO_MAP_ID';

export const GOOGLE_MAPS_LIBRARIES = ['geometry', 'geocoding', 'marker'] as const;

export function resolveGoogleMapId(mapId: string | null | undefined): string {
  const trimmed = mapId?.trim();
  if (trimmed) return trimmed;
  const fromEnv = process.env.NEXT_PUBLIC_GOOGLE_MAPS_MAP_ID?.trim();
  if (fromEnv) return fromEnv;
  return GOOGLE_MAPS_DEMO_MAP_ID;
}
